import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
var _excluded = ["label", "selected", "href", "link", "className", "id"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.string.link.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Link from './Link';
var propTypes = {
  /**
   text that will be displayed for the tab
  */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /** the tab href */
  href: PropTypes.string,
  /** the tab link node */
  link: PropTypes.node,
  /** specifies if the tab is selected, set internally by the parent Tabs */
  selected: PropTypes.bool,
  /** tab panel content */
  children: PropTypes.node,
  /** extra styling for the tab */
  className: PropTypes.string,
  /** used by the parent Tabs to indicate the currently selected tab.
   * Defaults to tab-{tabIndex}. eg: tab-0 for the first tab in a tab list */
  id: PropTypes.string
};
var defaultProps = {
  selected: false,
  children: undefined,
  href: '',
  link: undefined,
  className: undefined,
  id: undefined
};
var Tab = function Tab(_ref) {
  var label = _ref.label,
    selected = _ref.selected,
    href = _ref.href,
    link = _ref.link,
    className = _ref.className,
    id = _ref.id,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var styleClass = classnames('wds-c-tab', {
    'wds-u-current': selected
  }, className);
  var childLabel = /*#__PURE__*/React.createElement("span", null, label);
  return /*#__PURE__*/React.createElement(Link, _extends({
    className: styleClass,
    "aria-selected": selected,
    role: "tab",
    type: "default",
    tabIndex: 0,
    id: id,
    to: href,
    link: link
  }, !href && !link && {
    onClick: function onClick(e) {
      e.preventDefault();
    }
  }, otherProps), childLabel);
};
Tab.propTypes = propTypes;
Tab.defaultProps = defaultProps;
export default Tab;